import { useTranslation } from '@axo/shared/i18n';
import { Stack } from '@axo/ui-core/components/layout/item';
import { Text } from '@axo/ui-core/components/typography';
import { CarDebt } from './CarDebt';
import { CreditCardDebt } from './CreditCardDebt';
import { HousingDebt } from './HousingDebt';
import { PersonalDebt } from './PersonalDebt';
import { StudentDebt } from './StudentDebt';

export const CoApplicantDebt = () => {
  const { t } = useTranslation();

  return (
    <>
      <Text>
        <b>{t('AddCoApplicant.CoApplicantDebt')}</b>
      </Text>

      <Stack gap="3xs">
        <HousingDebt />
        <CarDebt />
        <StudentDebt />
        <CreditCardDebt />
        <PersonalDebt />
      </Stack>
    </>
  );
};
